import React from "react";

import loaderImg from "../assets/images/circle-loader.png";

export default function Loader() {
  return (
    <>
      <div className="preloader-outer">
        <div className="tk-preloader d-flex justify-content-center align-items-center w-100 h-100">
          <img
            className="fa-spin"
            src={loaderImg}
            alt="image description"
            width={20}
            height={20}
             
          />
        </div>
      </div>
    </>
  );
}
